<template>
  <v-row style="height: 85vh">
    <v-col cols="3">
      <note-sidebar></note-sidebar>
    </v-col>
    <v-col cols="9">
      <router-view></router-view>
    </v-col>
    <v-spacer></v-spacer>
  </v-row>
</template>

<script>
import NoteSidebar from "./note-sidebar.vue";
export default {
  components: {
    NoteSidebar,
  },
  mounted() {
    this.$store.dispatch("notesModule/validateRenderedFamilies");
  },
  beforeRouteUpdate(to, from, next) {
    // if changing routes from a "family" component then only validate that family
    if (from.query.familyId) {
      this.$store.dispatch("notesModule/validateFamily", {
        familyId: from.query.familyId,
      });
    } else if (Number.isInteger(from.query.pos)) {
      this.$store.dispatch("notesModule/validateFamily", {
        familyId: this.renderedFamilies[from.query.pos].familyId,
      });
    }
    // else validate all families
    else {
      this.$store.dispatch("notesModule/validateRenderedFamilies");
    }
    next();
  },
  computed: {
    renderedFamilies: function () {
      return this.$store.getters["notesModule/getRenderedFamilies"] || [];
    },
  },
};
</script>
